import React from "react";
import { formatISKInput } from "../lib/currency";

export function CurrencyInput({ value, onChange, ...props }) {
  return (
    <input
      {...props}
      type="text"
      inputMode="numeric"
      value={formatISKInput(value)}
      onChange={(e) => onChange?.(formatISKInput(e.target.value))}
    />
  );
}